import React from 'react';

const Trope3: React.FC = () => {
  return (
    <g
      className="prefix__trope-decor-3 prefix__trope-decor"
      transform="translate(120, 236)"
    >
      <g id="e314df43-19b4-4f3e-81c7-f7d942e47e6c" data-name="road">
        <path
          d="M696.36,59,677.5,73s-101-12-125,8-42,53-65,48-115,5-164,37-245,46-249,107,75,53,75,53l23,3c9,11,70,19,92,30l12,23c-30-18-111-26.17-166-37C47,332.5,56,263.5,56,263.5c3-33-56-31-56-31l25-8c20.37,7.41,48.11-.67,52.12-1.92,35.81-26.28,119-40.77,135.38-50.58,20-12-17-19-17-19l27,1c12,9,54,5,113-27s133-18,142-21-8-13-8-13l11-8a67,67,0,0,0,24,7c13,1,10-7,48-25S696.36,59,696.36,59Z"
          fill="#415c93"
        />
        <path
          d="M268,368.5s-94-25-141-32-74-39-58-79,112-66,181-82,108-52,157-56,81,1,96-8,30-27,44-35,41-18,82-14S688,65,688,65"
          fill="none"
          stroke="#dcceea"
          strokeMiterlimit="10"
          strokeDasharray="12"
        />
        <path
          d="M1033,138.5c57,4,112.5,5.5,169.5,48.5s27,80-3,85-176.82-13.93-202,29c-27.23,46.43,51.11,79.05,166,63,0,0,3,10,11,17,0,0-45,28-50,47,0,0-19-15-28-6s40-24,30-31S950,374.88,946.5,324c-2-29,41-62,126-67s125.62,9.66,133-17c18-65-212-85-212-85Z"
          fill="#415c93"
        />
        <path
          d="M1016.57,145.36S1135.5,151,1184.5,188s53,66,10,75-132.35-5-180.5,12.5c-65.88,23.9-55.38,57.53-8.5,76.5,24.87,10.07,98,32,149,25,0,0-31,34-35,40"
          fill="none"
          stroke="#dcceea"
          strokeMiterlimit="10"
          strokeDasharray="12"
        />
        <path
          d="M1034.54,138.08l-39,16.56c-14-8.37-69.38-1.6-107.53-11.14-24-6-20.5-23.5-44.5-48.5s-73-17-73-17l13.39-21.4S806.5,55,851.5,73c20.84,8.33,26,20.31,28.66,30.38-.16-1.19-.25-2-.27-2.23.85,4.84,14.25,19.55,30.93,20.2,1,0,1.77.09,2.41.17h0C953.64,122.47,1034.54,138.08,1034.54,138.08Z"
          fill="#415c93"
        />
        <path
          d="M1011.24,146.49C995,139,976.7,138.47,944.5,135c-30-3.24-52.25,10.05-69.5-24.5C861.72,83.9,847.5,83,822.5,73s-45.67-7-45.67-7"
          fill="none"
          stroke="#dcceea"
          strokeMiterlimit="10"
          strokeDasharray="12"
        />
      </g>
      <g id="b11a0c11-47f4-4dfb-a489-f4e4465190ca" data-name="decor">
        <g>
          <image
            width="97"
            height="96"
            transform="translate(127.5 301)"
            xlinkHref="data:image/png;base64,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"
          />
          <polygon
            points="175.94 350.55 175.94 359.48 165.39 344.45 175.94 338.36 175.94 345.88 186.5 351.87 186.5 356.64 175.94 350.55"
            fill="none"
            stroke="#f416ca"
            strokeLinejoin="round"
            strokeWidth="2.13"
          />
          <line
            x1="179.28"
            y1="353.18"
            x2="179.28"
            y2="374.5"
            fill="none"
            stroke="#f416ca"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2.13"
          />
          <line
            x1="179.28"
            y1="353.18"
            x2="179.28"
            y2="374.5"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.3"
          />
          <polygon
            points="175.94 350.55 175.94 359.48 165.39 344.45 175.94 338.36 175.94 345.88 186.5 351.87 186.5 356.64 175.94 350.55"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.3"
          />
        </g>
        <g>
          <polygon
            points="588.98 43.77 588.98 47.5 583.46 40.58 588.98 37.39 588.98 41.32 596 40.5 595 44.5 588.98 43.77"
            fill="none"
            stroke="#4ff219"
            strokeLinejoin="round"
            strokeWidth="1.11"
          />
          <polygon
            points="588.98 43.77 588.98 47.5 583.46 40.58 588.98 37.39 588.98 41.32 596 40.5 595 44.5 588.98 43.77"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.15"
          />
          <image
            width="87"
            height="85"
            transform="translate(546.5)"
            xlinkHref="data:image/png;base64,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"
          />
          <line
            x1="591"
            y1="44.5"
            x2="590.72"
            y2="56.29"
            fill="none"
            stroke="#4ff219"
            strokeLinejoin="round"
            strokeWidth="1.11"
          />
          <line
            x1="591"
            y1="44.5"
            x2="590.72"
            y2="56.29"
            fill="none"
            stroke="#f7e4f4"
            strokeLinejoin="round"
            strokeWidth="0.15"
          />
        </g>
        <g>
          <g>
            <path
              d="M676.5,74s36-20,94,4L784,57.5S727.5,37,696.5,59Z"
              fill="#415c93"
            />
            <line
              x1="676"
              y1="51.5"
              x2="676"
              y2="73.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="725"
              y1="57.5"
              x2="725"
              y2="66.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="735"
              y1="39.5"
              x2="735"
              y2="48.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="773"
              y1="55.5"
              x2="773"
              y2="77.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="784"
              y1="35.5"
              x2="784"
              y2="57.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <line
              x1="696"
              y1="37.5"
              x2="696"
              y2="59.5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <path
              d="M676,54.72s24,16.78,49-.22c0,0,15,15,48,5"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
            />
            <path
              d="M696.49,40.38S712,54.29,735,41.39c0,0,36,16.77,49-3.56"
              fill="none"
              stroke="#adbcd8"
              strokeLinecap="round"
              strokeMiterlimit="10"
            />
          </g>
          <path
            d="M776.83,66s-36.46-17.27-86.65-2.88"
            fill="none"
            stroke="#dcceea"
            strokeMiterlimit="10"
            strokeDasharray="12"
          />
        </g>
        <g>
          <polygon
            points="805.04 68.39 815.77 74.58 815.77 62.19 826.5 80.78 815.77 86.97 815.77 79.11 805.04 73.02 805.04 68.39"
            fill="none"
            stroke="#f916ce"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.24"
          />
          <polygon
            points="805.04 68.39 815.77 74.58 815.77 62.19 826.5 80.78 815.77 86.97 815.77 79.11 805.04 73.02 805.04 68.39"
            fill="none"
            stroke="#f9eff8"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.23"
          />
          <line
            x1="810.92"
            y1="76.36"
            x2="810.92"
            y2="100"
            fill="none"
            stroke="#f916ce"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.24"
          />
          <image
            width="96"
            height="99"
            transform="translate(767.5 25)"
            xlinkHref="data:image/png;base64,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"
          />
        </g>
      </g>
    </g>
  );
};

export default Trope3;
